import {
  addAlert as requestAddAlert,
  editAlert as requestEditAlert
} from '@common/graphql/mutations/alerts';
import getGqlClient from '@common/graphql/client';

export const editAlert = async (id, alertData) => {
  try {
    const alertToEdit = { ...alertData, id };
    const newAlert = await requestEditAlert(getGqlClient())(alertToEdit);
    return newAlert;
  } catch (error) {
    throw new Error(error);
  }
};

export const addAlert = async newAlertData => {
  try {
    const newAlert = await requestAddAlert(getGqlClient())(newAlertData);
    return newAlert;
  } catch (error) {
    throw new Error(error);
  }
};

export default {
  editAlert,
  addAlert
};
